<template>
  <div id="app">
    <Nav></Nav>
    <router-view class="main-content"></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import Nav from './components/Nav';
import Footer from './components/Footer';
export default {
  name: 'app',
  components: {
    Nav,
    Footer,
  }
}
</script>

<style lang="less">
@import url('./assets/style/common.less');
@import url('./assets/style/colors.less');
html,body{
  margin:0;
  padding:0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  margin: 0 auto;
  background: #e3e0e0;
  overflow-x: hidden;
}
.el-submenu__title{
  height: 50px;
}
@media screen and (max-width: 992px) {
  html,body{
    width: 100%;
    height: 100%;
    background: #e3e0e0;
  }
  #app {
    // height: 100%;
    background-repeat: initial;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue